import { handleActions, createAction } from 'redux-actions';
import update from 'immutability-helper';
import mapActions from '@goodwaygroup/react-map-actions';

// Actions
export const actions = mapActions([
    'FETCH_LIST',
    'FETCH_LIST_SUCCESS',
], 'OFFER');

// Action Creators
export const fetchList = createAction(actions.FETCH_LIST);
export const fetchListSuccess = createAction(actions.FETCH_LIST_SUCCESS);

// Reducers
const initialState = {
    list: [],
    listFetched: false
};

export default handleActions({
    [actions.FETCH_LIST_SUCCESS]: (state, action) => {
        const updatedData = {
            list: { $set: action.payload },
            listFetched: { $set: true }
        };
        return update(state, updatedData);
    }
}, initialState);



// WEBPACK FOOTER //
// ./src/services/offers/duck.js